var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"6rem"}},[_c('img',{attrs:{"src":"logo.png"}}),_c('h2',{staticClass:"mt-3"},[_vm._v("We Serve & Do Better")])])])
}]

export { render, staticRenderFns }